import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: `${API}/api` });

// Attach token to all requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("admin_token");
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

// Public
export const fetchNews = () => api.get("/news").then((r) => r.data);
export const fetchClients = () => api.get("/clients").then((r) => r.data);
export const fetchCountries = () => api.get("/countries").then((r) => r.data);
export const submitProfileDownload = (data) => api.post("/download-profile", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);

// Auth
export const adminLogin = (data) => api.post("/admin/login", data).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);

// Admin CRUD
export const adminGetStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminSeed = () => api.post("/admin/seed").then((r) => r.data);

export const adminGetNews = () => api.get("/news").then((r) => r.data);
export const adminCreateNews = (data) => api.post("/admin/news", data).then((r) => r.data);
export const adminUpdateNews = (id, data) => api.put(`/admin/news/${id}`, data).then((r) => r.data);
export const adminDeleteNews = (id) => api.delete(`/admin/news/${id}`).then((r) => r.data);

export const adminGetClients = () => api.get("/clients").then((r) => r.data);
export const adminCreateClient = (data) => api.post("/admin/clients", data).then((r) => r.data);
export const adminUpdateClient = (id, data) => api.put(`/admin/clients/${id}`, data).then((r) => r.data);
export const adminDeleteClient = (id) => api.delete(`/admin/clients/${id}`).then((r) => r.data);
export const adminUploadClientLogo = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/admin/clients/${id}/logo`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const adminGetCountries = () => api.get("/countries").then((r) => r.data);
export const adminCreateCountry = (data) => api.post("/admin/countries", data).then((r) => r.data);
export const adminUpdateCountry = (id, data) => api.put(`/admin/countries/${id}`, data).then((r) => r.data);
export const adminDeleteCountry = (id) => api.delete(`/admin/countries/${id}`).then((r) => r.data);

export const adminGetLeads = () => api.get("/admin/leads").then((r) => r.data);
export const adminDeleteLead = (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data);
export const adminGetContacts = () => api.get("/admin/contacts").then((r) => r.data);
export const adminDeleteContact = (id) => api.delete(`/admin/contacts/${id}`).then((r) => r.data);
export const adminReorderClients = (ids) => api.post("/admin/clients/reorder", { ids }).then((r) => r.data);
export const adminGetAnalytics = () => api.get("/admin/analytics").then((r) => r.data);
export const adminGetSettings = () => api.get("/admin/settings").then((r) => r.data);
export const adminUploadProfile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/profile-document", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// RSS Feeds
export const adminGetFeeds = () => api.get("/admin/feeds").then((r) => r.data);
export const adminCreateFeed = (data) => api.post("/admin/feeds", data).then((r) => r.data);
export const adminToggleFeed = (id) => api.put(`/admin/feeds/${id}/toggle`).then((r) => r.data);
export const adminDeleteFeed = (id) => api.delete(`/admin/feeds/${id}`).then((r) => r.data);
export const adminRefreshFeeds = () => api.post("/admin/feeds/refresh").then((r) => r.data);

// Site Content (CMS)
export const fetchSiteContent = () => api.get("/site-content").then((r) => r.data);
export const adminUpdateSiteContent = (key, value) => api.put(`/admin/site-content/${key}`, value).then((r) => r.data);
export const adminUploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminUploadFavicon = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload-favicon", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const getLogoUrl = (path) => `${API}/api/files/${path}`;
